import MyWallet from './MyWallet';

export default MyWallet;
